import { useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { useToast } from '@sketch/toasts'

export const useIntegrationIdentityURLHandler = () => {
  const location = useLocation()
  const history = useHistory()
  const { showToast } = useToast()

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search)
    const integrationLinked = urlParams.get('integration_identity_linked')
    const errorParam = urlParams.get('error')

    if (!integrationLinked && !errorParam) {
      return
    }

    if (integrationLinked === 'true') {
      showToast('Account connected successfully')
    }

    if (errorParam === 'integration_failed') {
      showToast(
        'There was an issue connecting your account, please try again',
        'negative'
      )
    }

    // Remove only the handled params, preserving any others
    urlParams.delete('integration_identity_linked')
    urlParams.delete('error')
    const remainingParams = urlParams.toString()
    const newSearch = remainingParams ? `?${remainingParams}` : ''

    history.replace(`${location.pathname}${newSearch}`)
  }, [location, history, showToast])
}
